import { render, staticRenderFns } from "./CreateAct.vue?vue&type=template&id=7c2dacbd&scoped=true&"
import script from "./CreateAct.vue?vue&type=script&lang=js&"
export * from "./CreateAct.vue?vue&type=script&lang=js&"
import style0 from "./CreateAct.vue?vue&type=style&index=0&id=7c2dacbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2dacbd",
  null
  
)

export default component.exports